import React, { useEffect, useState } from "react"
import UserMessage from "../ChatBody/UserMessage"
import BotMessage from "../ChatBody/BotMessage"
import LoaderImg from "../../../assets/images/ttd/ellipsis.gif"
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import RatingComp from "../TalkkToDocs/RatingComp";
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { btoa } from '../../../cryptographic/crypto';
import BotMessageTtd from "../ChatBody/BotMessageTTD"

function MessageList({ chatsBackUp, formRequested, setFormRequested, prefLang, setPrefLang, preChatData, setStartChat, startChat, socket,
    botInfo, showFullImage, chatIsClose, closeChatEff, setChatIsClose, setCloseChatEff, setCloseFloat, setIsLang, setOpenFeedback, openFeedback, noFeedback,
    setNoFeedback, openBot, setOpenBot, setQuickRes, botImage, appointment,
    setAppointment, btnTypeG, setbtnTypeG, hideIframe, setHideFooter,
    scrollToBottom, openMic, events, setSideViewer, pdfSideViwer, agentName, messages,disableResp,setDisableResp,scrollableDivRef }) {

    const createUserBotPairs = (msgs) => {
        const pairs = [];
        let currentPair = { bot_messages: [] };

        msgs.forEach((message) => {
            if (message?.userId || message?.messageText) {
                if (message?.userId === undefined) {
                    // When encountering a new user message, save the current pair and start a new one
                    if (currentPair.user_message) {
                        pairs.push(currentPair);
                        currentPair = { bot_messages: [] };
                    }
                    currentPair.user_message = message;
                } else if (message?.userId && message?.userId?.isBot === "Y") {
                    if(message?.template?.template?.elements?.buttons?.filter(component => component.mode === "disable_text_box").length){
                        // for close chat
                        if (currentPair.user_message) {
                            pairs.push(currentPair);
                            currentPair = { bot_messages: [] };
                        }
                        pairs.push(
                            {
                                user_message : {
                                    messageText : "/closechat",
                                    updatedAt: message?.updatedAt
                                },
                                bot_messages : [message]
                            }
                        );
                    }else{
                        if (message?.template) {
                            // If it's a bot message, add it to the bot_messages array
                            currentPair.bot_messages.push(message);
                        }
                    }
                }
            }
        });

        // Push the last pair if there's any content
        if (currentPair.user_message || currentPair.bot_messages.length > 0) {
            pairs.push(currentPair);
        }

        return pairs;
    };

    // const messagePairs = createUserBotPairs(messages);

    const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
    };

    const formatdate2 = (dateStr) => {
        const givenDate = new Date(dateStr);
        const currentDate = new Date();
        const diffInMillis = currentDate - givenDate;
        const diffInSeconds = Math.floor(diffInMillis / 1000);
        const diffInMinutes = Math.floor(diffInMillis / (1000 * 60));
        const diffInHours = Math.floor(diffInMillis / (1000 * 60 * 60));

        let output;

        // Check the difference and set the output accordingly
        if (diffInSeconds <= 30) {
            output = "just now";
        } else if(diffInMinutes < 1) {
            output = "1 minute ago";
        } else if (diffInMinutes < 5) {
            output = `${diffInMinutes} minutes ago`;
        } else if (diffInHours === 1) {
            output = "1 hour ago";
        } else {
            // Format the given date in the desired format
            const dayLocal = String(givenDate.getDate()).padStart(2, '0');
            const monthLocal = String(givenDate.getMonth() + 1).padStart(2, '0');
            const yearLocal = givenDate.getFullYear();
            const hoursLocal = String(givenDate.getHours()).padStart(2, '0');
            const minutesLocal = String(givenDate.getMinutes()).padStart(2, '0');
            output = `${dayLocal} - ${monthLocal} - ${yearLocal} | ${hoursLocal}:${minutesLocal}`;
        }
        return output
    }

    const giveRatings = (rate,msg,reason) => {
        let rateData = {
            conversation_id: msg?.conversationId?.Id,
            message_id: msg?.id,
            reaction: rate
        }
        if(reason){
            rateData.reason = reason
        }
        // console.error(rateData)
        socket.emit(btoa(["saveReaction", rateData]));
    }

    return (
        <>
            {createUserBotPairs(messages).map((item, key) => (
                item?.user_message ?
                    <div className={`ttd-new-message-wrapper ${(item?.user_message?.messageText === "/st_greetings" || item?.user_message?.messageText === "/closechat") ? "hide-user-message" : ""}`} key={key}>
                        {
                            item?.user_message ?
                                <div className="ttd-message-headning">
                                    <UserMessage message={item?.user_message?.messageText} botInfo={botInfo} setOpenFeedback={setOpenFeedback} openFeedback={openFeedback} noFeedback={noFeedback} setNoFeedback={setNoFeedback} openBot={openBot} setOpenBot={setOpenBot} time={new Date(item.user_message.updatedAt).toLocaleString("en-US", options)} prefLang={prefLang} messageArray={messages} showFullImage={showFullImage} />
                                    <div className="date-wrapper">{formatdate2(item.user_message.updatedAt)}</div>
                                </div>
                                :
                                <></>
                        }
                        {
                            item.bot_messages?.length > 0 ?
                                <div className="ttd-message-body">
                                    {item.bot_messages.map((msg, index) => (
                                        <BotMessageTtd setPrefLang={setPrefLang} prefLang={prefLang} chatIsClose={chatIsClose} closeChatEff={closeChatEff} setChatIsClose={setChatIsClose} setCloseChatEff={setCloseChatEff} setCloseFloat={setCloseFloat} socket={socket} setIsLang={setIsLang} setFormRequested={setFormRequested} botInfo={botInfo} setOpenFeedback={setOpenFeedback} openFeedback={openFeedback} noFeedback={noFeedback} setNoFeedback={setNoFeedback} openBot={openBot} setOpenBot={setOpenBot} message={msg} agent={agentName} time={new Date(msg.updatedAt).toLocaleString("en-US", options)} setStartChat={setStartChat} setQuickRes={setQuickRes} showFullImage={showFullImage} botImage={botImage} isBot={msg?.userId?.isBot} appointment={appointment} setAppointment={setAppointment} btnTypeG={btnTypeG} setbtnTypeG={setbtnTypeG} hideIframe={hideIframe} setHideFooter={setHideFooter} 
                                        indexLength={messages.findIndex((data)=> data.id === msg.id)} arrayLength={messages} prevUser={"bot"} scrollToBottom={scrollToBottom} openMic={openMic} events={events} setSideViewer={setSideViewer} pdfSideViwer={pdfSideViwer} disableResp={disableResp} setDisableResp={setDisableResp} />
                                    ))}
                                    <div className={`footer-icons-wrapper d-flex align-items-center justify-content-end`}>
                                        {
                                            item.bot_messages.filter((d)=> !d?.template?.hasOwnProperty('ssml'))[0]?.step === 99 && (item.bot_messages[0]?.tags && !item.bot_messages[0]?.tags?.some((data)=> data.includes("st_"))) ?
                                                botInfo?.data?.mobileAppConfig?.reactionEnable && botInfo?.data?.mobileAppConfig?.reactionEnable === "N" ?
                                                    <></>
                                                :
                                                    <RatingComp message={item.bot_messages.filter((d)=> !d?.template?.hasOwnProperty('ssml'))[0]} giveRatings={giveRatings} scrollableDivRef={scrollableDivRef} />
                                            :
                                                <></>
                                        }
                                        {/* <div >
                                        <BookmarkBorderIcon onClick={() => handleSaveMessage()}/>
                                        </div>
                                        <div>
                                        <BookmarkIcon />
                                        </div> */}
                                    </div>
                                </div>
                                :
                                createUserBotPairs(messages)?.length-1 === key ?
                                    <div className="ttd-message-body">
                                        <div className="message-loaders">
                                            <img src={LoaderImg} className="loader-img" />
                                        </div>
                                    </div>
                                :
                                    <></>
                        }
                    </div>
                    :
                    <></>
            ))}
        </>
    )
}
export default MessageList